import type { OnboardingAddress } from "../types";

const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;

// formatOnboardingAddress renders the structured address as a one-line string
// for the summary step, e.g. "Rua X, 100 — Centro, Natal/RN".
export function formatOnboardingAddress(a: OnboardingAddress): string {
	const line1 = [a.street, a.number].filter(Boolean).join(", ");
	const line2 = [a.neighborhood, [a.city, a.state].filter(Boolean).join("/")]
		.filter(Boolean)
		.join(", ");
	return [line1, line2].filter(Boolean).join(" — ");
}

export function dateToRFC3339(value: string): string | null {
	const trimmed = value.trim();
	if (!DATE_ONLY.test(trimmed)) return null;
	return `${trimmed}T00:00:00Z`;
}

// maskCurrencyBRL reads the typed digits as cents, so "500000" renders as
// "R$ 5.000,00". Empty input stays empty to keep the field optional.
export function maskCurrencyBRL(value: string): string {
	const digits = value.replace(/\D/g, "").slice(0, 15);
	if (digits === "") return "";
	const padded = digits.padStart(3, "0");
	const reais = Number(padded.slice(0, -2)).toLocaleString("pt-BR");
	return `R$ ${reais},${padded.slice(-2)}`;
}

export function sanitizeArea(value: string): string {
	return value.replace(/m²|m2/gi, "").replace(/\s+/g, "").replace(/\./g, "");
}
